import { render, staticRenderFns } from "./ReportImageUpload.vue?vue&type=template&id=2fefe4d6&scoped=true"
import script from "./ReportImageUpload.vue?vue&type=script&lang=ts"
export * from "./ReportImageUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefe4d6",
  null
  
)

export default component.exports